import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ChatBot from "./components/ChatBot";
import HomePage from "./pages/Home";
import ServicesPage from "./pages/Services";
import RemodelingPage from "./pages/Remodeling";
import PortfolioPage from "./pages/Portfolio";
import AssessmentPage from "./pages/Assessment";
import HowItWorksPage from "./pages/HowItWorks";
import WhyValenRockPage from "./pages/WhyValenRock";
import ContactPage from "./pages/Contact";
import AdminPage from "./pages/Admin";
import AdminLoginPage from "./pages/AdminLogin";
import NotFoundPage from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Disclaimer from "./pages/Disclaimer";
import BrochurePage from "./pages/Brochure";
import ReviewsPage from "./pages/Reviews";
import AboutPage from "./pages/About";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* Hidden brochure page - not in navigation */}
          <Route path="/brochure" element={<BrochurePage />} />
          <Route path="/reviews" element={
            <>
              <Header />
              <ReviewsPage />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <AboutPage />
              <Footer />
            </>
          } />
          <Route path="/" element={
            <>
              <Header />
              <HomePage />
              <Footer />
            </>
          } />
          <Route path="/services" element={
            <>
              <Header />
              <ServicesPage />
              <Footer />
            </>
          } />
          <Route path="/remodeling" element={
            <>
              <Header />
              <RemodelingPage />
              <Footer />
            </>
          } />
          <Route path="/remodeling/portfolio" element={
            <>
              <Header />
              <PortfolioPage />
              <Footer />
            </>
          } />
          <Route path="/assessment" element={
            <>
              <Header />
              <AssessmentPage />
              <Footer />
            </>
          } />
          <Route path="/how-it-works" element={
            <>
              <Header />
              <HowItWorksPage />
              <Footer />
            </>
          } />
          <Route path="/why-valenrock" element={
            <>
              <Header />
              <WhyValenRockPage />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <ContactPage />
              <Footer />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <Header />
              <PrivacyPolicy />
              <Footer />
            </>
          } />
          <Route path="/terms-of-service" element={
            <>
              <Header />
              <TermsOfService />
              <Footer />
            </>
          } />
          <Route path="/disclaimer" element={
            <>
              <Header />
              <Disclaimer />
              <Footer />
            </>
          } />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <ChatBot />
      </BrowserRouter>
    </div>
  );
}

export default App;
